import { getUser, isHostLogin } from './auth';

export const goToMyPage = (navigate) => {
  // host
  if (isHostLogin()) {
    navigate('/host-dashboard');
    return;
  }

  // user（exhibitor / corporate）
  const user = getUser();
  if (!user || !user.mypage_url) return;

  navigate(user.mypage_url);
};